import { render, staticRenderFns } from "./ClientContactListing.vue?vue&type=template&id=01d52638"
import script from "./ClientContactListing.vue?vue&type=script&lang=js"
export * from "./ClientContactListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports